import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchGrouptripsDtlbannersec } from "../services/GrouptripsDtlbannersec";
import { fetchGroupdescriptions } from "../services/GrouptripsDtlbannersec";
import { API_BASE } from "../api/apiConfig";

const ReadMoreText = ({ text = "", limit = 120, className = "" }) => {
  const [expanded, setExpanded] = useState(false);

  if (!text) return null;

  const shortText = text.slice(0, limit);
  const isLong = text.length > limit;

  return (
    <p className={className}>
      {expanded || !isLong ? text : shortText + "... "}
      {isLong && (
        <button
          onClick={() => setExpanded(!expanded)}
          className="text-primary font-medium ml-1"
        >
          {expanded ? "Read less" : "Read more"}
        </button>
      )}
    </p>
  );
};

const GrouptripsDtlmenu = () => {
  const { id } = useParams();
  const [GroupTripsDtl, setGroupTripsDtl] = useState(null);
  const [GroupTripsdetail, setGroupTripsdec] = useState(null);
  const [itineraryDays, setItineraryDays] = useState([]);
  const [loading, setLoading] = useState(true);
  const [GroupTripsdetailall, setGroupTripsdecall] = useState(null);
  const [openDay, setOpenDay] = useState(1);

  useEffect(() => {
    const loadBanner = async () => {
      const res = await fetchGrouptripsDtlbannersec(decodeURIComponent(id));

      if (res?.status && res?.data?.length > 0) {
        setGroupTripsDtl(res.data[0]);
      }
      setLoading(false);
    };

    loadBanner();
  }, [id]);

  useEffect(() => {
    const loadBanner = async () => {
      const res = await fetchGroupdescriptions(decodeURIComponent(id));

      if (res?.status && res?.data?.length > 0) {
        setGroupTripsdecall(res.data);
      }
      setLoading(false);
    };

    loadBanner();
  }, [id]);

  useEffect(() => {
    const loadBanner = async () => {
      const res = await fetchGroupdescriptions(decodeURIComponent(id));

      if (res?.status && res?.data?.length > 0) {
        setGroupTripsdec(res.data[0]);
      }
      setLoading(false);
    };

    loadBanner();
  }, [id]);

  useEffect(() => {
    const loadItinerary = async () => {
      const res = await fetchGroupdescriptions(decodeURIComponent(id));

      if (res?.status && Array.isArray(res.data)) {
        const formatted = res.data.map((item, index) => ({
          day: index + 1,
          title: item.coveredplace,
          description: item.descriptionplace,
        }));
        setItineraryDays(formatted);
      }
      setLoading(false);
    };

    loadItinerary();
  }, [id]);

  if (loading) return <div>Loading...</div>;
  if (!GroupTripsDtl) return <div>No data found</div>;

  // Split covered_place into array of destinations
  const destinations = GroupTripsDtl?.covered_place
    ? GroupTripsDtl.covered_place
        .split(",")
        .map((place) => place.trim())
        .filter(Boolean)
    : [];


  // Split covered_place into array of inclusion
  const inclusion = GroupTripsdetail?.inclusion
    ? GroupTripsdetail.inclusion
        .split("@@")
        .map((place) => place.trim())
        .filter(Boolean)
    : [];

  // Split covered_place into array of exclusion
  const exclusion = GroupTripsdetail?.exclusion
    ? GroupTripsdetail.exclusion
        .split("@@")
        .map((exclusiondata) => exclusiondata.trim())
        .filter(Boolean)
    : [];

  const meal = GroupTripsdetail?.meal
    ? GroupTripsdetail.meal
        .split("@@")
        .map((mealdata) => mealdata.trim())
        .filter(Boolean)
    : [];

  const special_notes = GroupTripsdetail?.special_notes
    ? GroupTripsdetail.special_notes
        .split("@@")
        .map((specialnotesdata) => specialnotesdata.trim())
        .filter(Boolean)
    : [];
  

  const Itinerarydata = Array.isArray(GroupTripsdetailall)
  ? GroupTripsdetailall.map((item, index) => ({
      day: index + 1, // API me day nahi hai → index se banayenge
      title: item.coveredplace || "N/A",
      description: item.descriptionplace
        ? item.descriptionplace.replace(/<[^>]+>/g, "") // html remove
        : "",
      image: item.imageplace
        ? `${API_BASE}public/${item.imageplace}`
        : `${API_BASE}public/default.jpg`,
      meals: item.mealslace ? item.mealslace.replace(/@/g, ", ") : "No meals",
      stay: item.stayplace || "No stay",
      tags: item.mealslace ? item.mealslace.split("@") : [],
    }))
  : [];


  // ✅ Meals count logic (NOW WORKING)
// count object
const mealsCount = { Breakfast: 0, Lunch: 0, Dinner: 0 };

// agar API array return kar rahi hai
if (Array.isArray(GroupTripsdetailall)) {
  GroupTripsdetailall.forEach((item) => {
    if (item?.mealslace) {
      item.mealslace.split("@").forEach((meal) => {
        const m = meal.trim().toLowerCase();

        if (m === "breakfast") mealsCount.Breakfast += 1;
        if (m === "lunch") mealsCount.Lunch += 1;
        if (m === "dinner") mealsCount.Dinner += 1;
      });
    }
  });
}

// ⭐ YE MISS THA — meals array banana padega
const meals = [
  { name: "Breakfast", count: mealsCount.Breakfast },
  { name: "Lunch", count: mealsCount.Lunch },
  { name: "Dinner", count: mealsCount.Dinner },
];


const stays = Array.isArray(GroupTripsdetailall) ? GroupTripsdetailall : [];
const triphighlightdata = Array.isArray(GroupTripsdetailall) ? GroupTripsdetailall : [];



  if (loading) return <div>Loading...</div>;
  if (!itineraryDays.length) return <div>No itinerary found</div>;

  return (
       <>
        <div id="about" className="scroll-mt-28 mb-6">
          <div className="w-full rounded-xl border border-slate-100 bg-white p-4 shadow-sm md:p-6">
            <h2 className="mb-3 text-base font-bold text-slate-800 md:mb-4 md:text-xl">
              About This Trip
            </h2>
            <p className="whitespace-pre-line text-sm leading-relaxed text-slate-600 md:text-base">
              {GroupTripsDtl.available_time
              ? GroupTripsDtl.available_time
                  .replace(/<li>/g, '• ')    // replace <li> with bullet
                  .replace(/<\/li>/g, '\n')
                  .replace(/<[^>]+>/g, '')
              : "No available information"}
            </p>
          </div>


          <section>
              <h2 className="text-base md:text-2xl font-bold text-slate-900 mb-3 md:mb-6 mt-5">
                Trip Details
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 md:gap-4">
                <div className="bg-gradient-to-br from-primary/5 to-primary/10 rounded-xl md:rounded-2xl p-4 md:p-5">
                  <div className="flex items-center gap-2 md:gap-3 mb-3 md:mb-4">
                    <div className="w-8 h-8 md:w-10 md:h-10 rounded-lg md:rounded-xl bg-primary/20 flex items-center justify-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-map-pin h-4 w-4 md:h-5 md:w-5 text-primary"
                      >
                        <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                        <circle cx={12} cy={10} r={3} />
                      </svg>
                    </div>
                    <h3 className="font-semibold text-slate-900 text-sm md:text-base">
                      Destinations
                    </h3>
                  </div>
                  <div className="flex flex-wrap gap-1.5 md:gap-2">

                  {destinations.map((destinationsval, index) => (
                      <span className="bg-white/80 text-slate-700 text-xs md:text-sm px-2 md:px-3 py-0.5 md:py-1 rounded-full">
                        {destinationsval}
                      </span>
                  ))}

                  </div>
                </div>
                <div className="bg-gradient-to-br from-orange-50 to-orange-100/50 rounded-xl md:rounded-2xl p-4 md:p-5">
                  <div className="flex items-center gap-2 md:gap-3 mb-3 md:mb-4">
                    <div className="w-8 h-8 md:w-10 md:h-10 rounded-lg md:rounded-xl bg-orange-200/50 flex items-center justify-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-utensils h-4 w-4 md:h-5 md:w-5 text-orange-600"
                      >
                        <path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" />
                        <path d="M7 2v20" />
                        <path d="M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7" />
                      </svg>
                    </div>
                    <h3 className="font-semibold text-slate-900 text-sm md:text-base">
                      Meals Included
                    </h3>
                  </div>
                  <div className="grid grid-cols-3 gap-1.5 md:gap-2 text-center">

                  {meals.map((meal, index) => (
                    <div key={index} className="bg-white/80 rounded-lg md:rounded-xl p-1.5 md:p-2">
                      <p className="text-base md:text-xl font-bold text-orange-600">
                        {meal.count}
                      </p>
                      <p className="text-[10px] md:text-xs text-slate-500">
                        {meal.name}
                      </p>
                    </div>
                  ))}


                  </div>
                </div>
                <div className="bg-gradient-to-br from-blue-50 to-blue-100/50 rounded-xl md:rounded-2xl p-4 md:p-5">
                  <div className="flex items-center gap-2 md:gap-3 mb-3 md:mb-4">
                    <div className="w-8 h-8 md:w-10 md:h-10 rounded-lg md:rounded-xl bg-blue-200/50 flex items-center justify-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-home h-4 w-4 md:h-5 md:w-5 text-blue-600"
                      >
                        <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                        <polyline points="9 22 9 12 15 12 15 22" />
                      </svg>
                    </div>
                    <h3 className="font-semibold text-slate-900 text-sm md:text-base">
                      Stay Types
                    </h3>
                  </div>
                  <div className="space-y-1.5 md:space-y-2">
                    <div className="flex items-center gap-2">
                      {GroupTripsdetail.staytypes
                      ? GroupTripsdetail.staytypes
                          .replace(/<li>/g, '• ')    // replace <li> with bullet
                          .replace(/<\/li>/g, '\n')
                          .replace(/<[^>]+>/g, '')
                      : "No available information"}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          
          <section className="min-w-0">
            <h2 className="text-base md:text-2xl font-bold text-slate-900 mb-3 md:mb-6 mt-5">
              Where You'll Stay
            </h2>

            {/* ---------- MOBILE ---------- */}
            <div className="md:hidden scrollbar-custom pb-1">
              <div className="inline-flex gap-3">

                {stays.map((item, index) => (
                  <div
                    key={index}
                    className="w-56 flex-shrink-0 bg-white border border-slate-200 rounded-xl overflow-hidden"
                  >
                    <div className="relative h-32">
                      <img
                        src={`${API_BASE}/public/${item?.stay_image}`}
                        alt={item.stay_title}
                        className="absolute inset-0 w-full h-full object-cover"
                      />
                    </div>

                    <div className="p-3">
                      <h3 className="font-bold text-slate-900 text-sm mb-1">
                        {item.stay_title}
                      </h3>

                      <ReadMoreText
                        text={item.stay_description?.replace(/<[^>]+>/g, "")}
                        className="text-xs text-slate-600"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* ---------- DESKTOP ---------- */}
            <div className="hidden md:grid md:grid-cols-2 md:gap-5">
              {stays.map((item, index) => (
                <div
                  key={index}
                  className="bg-white border border-slate-200 rounded-xl overflow-hidden"
                >
                  <div className="relative h-44">
                    <img
                      src={`${API_BASE}/public/${item?.stay_image}`}
                      alt={item.stay_title}
                      className="absolute inset-0 w-full h-full object-cover"
                    />
                  </div>

                  <div className="p-4">
                    <h3 className="font-bold text-slate-900 text-base mb-1">
                      {item.stay_title}
                    </h3>

                    <ReadMoreText
                      text={item.stay_description?.replace(/<[^>]+>/g, "")}
                      className="text-sm text-slate-600"
                    />
                  </div>
                </div>
              ))}
            </div>
          </section>
          

          <section className="min-w-0">
              <h2 className="text-base md:text-2xl font-bold text-slate-900 mb-3 md:mb-6 mt-5">
                  Trip Highlights
              </h2>
              <div className="md:hidden overflow-x-auto scrollbar-hide pb-1">
              <div className="inline-flex gap-3">

          {triphighlightdata.map((itemval, index) => (
              <div className="relative w-44 h-56 flex-shrink-0 rounded-xl overflow-hidden">
              <img
                        src={`${API_BASE}/public/${itemval?.trip_image}`}
                        alt="Hands-on ChatGPT & Claude masterclass"
                        className="absolute inset-0 w-full h-full object-cover"
                      />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-3">
              <p className="text-white font-semibold text-sm leading-snug line-clamp-2">
                          {itemval.trip_title}
              </p>
              </div>
              </div>
          ))}


              </div>
              </div>

              <div className="hidden md:grid md:grid-cols-3 gap-4">

          
          {triphighlightdata.map((itemval, index) => (
              <div className="group relative aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                      src={`${API_BASE}/public/${itemval?.trip_image}`}
                      alt="Hands-on ChatGPT & Claude masterclass"
                      className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4">
              <p className="text-white font-semibold text-sm leading-snug line-clamp-2">
                        {itemval.trip_title}
              </p>
              </div>
              </div>
           
          ))}

           
             
              
           
              </div>
          </section>


          <div className="mt-4 md:mt-6 w-full rounded-xl border border-slate-100 bg-white p-4 shadow-sm md:p-6">
            <h3 className="text-base font-bold text-slate-800 mb-3 md:mb-4 md:text-xl">
              About the Organizer
            </h3>
            <div className="flex items-start gap-3 md:gap-4">
              <span className="relative flex shrink-0 overflow-hidden rounded-full h-12 w-12 md:h-14 md:w-14">
                <span className="flex h-full w-full items-center justify-center rounded-full bg-muted">
                  A
                </span>
              </span>
              <div className="flex-1">
                <h4 className="text-sm font-bold text-slate-800 md:text-base">
                  Adventure Trails India
                </h4>
                <div className="mt-1 flex flex-wrap items-center gap-2 md:gap-3 text-xs md:text-xs text-slate-600">
                  <div className="flex items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star mr-1 h-3.5 w-3.5 md:h-3.5 md:w-3.5 text-yellow-400 fill-yellow-400"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    4.8
                  </div>
                  <span>•</span>
                  <span>280{/* */} trips</span>
                  <span>•</span>
                  <span>Since {/* */}2014</span>
                </div>
                <p className="mt-2 text-xs md:text-sm text-slate-600 leading-relaxed">
                  Specialized adventure travel company with 10+ years of
                  experience organizing expeditions across the Himalayas. Safety
                  is our priority, adventure is our passion.
                </p>
                <button className="inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input hover:bg-accent hover:text-accent-foreground rounded-md mt-3 text-xs md:text-sm h-9 md:h-9 bg-transparent px-3 md:px-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-message-circle mr-1.5 h-4 w-4 md:h-4 md:w-4"
                  >
                    <path d="m3 21 1.9-5.7a8.5 8.5 0 1 1 3.8 3.8z" />
                  </svg>
                  Contact
                </button>
              </div>
            </div>
          </div>
        </div>
        <div id="itinerary" className="scroll-mt-28 mb-6">
          <div className="bg-white rounded-xl border border-slate-100 p-4 md:p-6 shadow-sm">
            <h3 className="text-base md:text-xl font-bold text-slate-800 mb-4 md:mb-6">
              Day-by-Day Itinerary
            </h3>

              <div className="space-y-4 md:space-y-6">
                {Itinerarydata.map((item) => {
                  const isOpen = openDay === item.day;
                  return (
                    <div key={item.day} className="group">
                      <div className="bg-white border border-slate-200 rounded-2xl md:rounded-3xl overflow-hidden transition-all duration-300 hover:shadow-lg">
                        {/* HEADER */}
                        <button
                          onClick={() =>
                            setOpenDay(isOpen ? null : item.day)
                          }
                          className="w-full flex items-stretch text-left"
                        >
                          <div className="relative w-24 sm:w-32 md:w-48 flex-shrink-0 hidden sm:block overflow-hidden">
                            <img
                              src={item.image}
                              alt={item.title}
                              className="absolute inset-0 w-full h-full object-cover"
                            />
                          </div>
                          {/* Content */}
                          <div className="flex-1 p-3 sm:p-4 md:p-6 flex items-center justify-between">
                            <div className="flex items-center gap-3 md:gap-4">
                              <div className="w-11 h-11 md:w-14 md:h-14 rounded-xl md:rounded-2xl bg-primary/10 flex flex-col items-center justify-center">
                                <span className="text-[9px] md:text-xs text-primary/70 uppercase">
                                  Day
                                </span>
                                <span className="text-base md:text-xl font-bold text-primary">
                                  {item.day}
                                </span>
                              </div>
                              {/* Title & tags */}
                              <div>
                                <h3 className="font-bold text-slate-900 text-sm md:text-lg mb-1">
                                  {item.title}
                                </h3>
                                {/*<div className="flex flex-wrap gap-1 md:gap-2">
                                  {item.tags.map((tag, i) => (
                                    <span
                                      key={i}
                                      className="bg-slate-100 px-2 py-0.5 rounded-full text-[10px] md:text-xs text-slate-500"
                                    >
                                      {tag}
                                    </span>
                                  ))}
                                </div>*/}
                              </div>
                            </div>
                            {/* Arrow icon */}
                            <svg
                              className={`h-4 w-4 md:h-5 md:w-5 text-slate-400 transition-transform ${
                                isOpen ? "rotate-180" : ""
                              }`}
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              strokeWidth={2}
                            >
                              <path d="m6 9 6 6 6-6" />
                            </svg>
                          </div>
                        </button>
                        {/* Body: show when open */}
                        {isOpen && (
                          <div className="border-t border-slate-100">
                            <div className="relative h-64 sm:h-80">
                              <img
                                src={item.image}
                                alt={item.title}
                                className="absolute inset-0 w-full h-full object-cover"
                              />
                              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                            </div>
                            <div className="p-5 sm:p-6">
                              <p className="text-slate-600 mb-5 leading-relaxed">
                                {item.description}
                              </p>

                              {/* Meals & Stay */}
                    <div className="flex flex-wrap gap-6 mobile-meals">
                      {/* Meals */}
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-xl bg-orange-50 flex items-center justify-center">
                          {/* Utensils SVG */}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5 text-orange-500"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth={2}
                          >
                            <path strokeLinecap="round" strokeLinejoin="round" d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" />
                            <path strokeLinecap="round" strokeLinejoin="round" d="M7 2v20" />
                            <path strokeLinecap="round" strokeLinejoin="round" d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3m0 0v7" />
                          </svg>
                        </div>
                        <div>
                          <p className="text-xs text-slate-400 uppercase tracking-wide">
                            Meals
                          </p>
                          <p className="text-sm font-medium text-slate-700">
                            {item.meals}
                          </p>
                        </div>
                      </div>

                      {/* Stay */}
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-xl bg-blue-50 flex items-center justify-center">
                          {/* Home SVG */}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5 text-blue-500"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth={2}
                          >
                            <path strokeLinecap="round" strokeLinejoin="round" d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                            <polyline strokeLinecap="round" strokeLinejoin="round" points="9 22 9 12 15 12 15 22" />
                          </svg>
                        </div>
                        <div>
                          <p className="text-xs text-slate-400 uppercase tracking-wide">
                            Stay
                          </p>
                          <p className="text-sm font-medium text-slate-700">
                            {item.stay}
                          </p>
                        </div>
                      </div>
                    </div>

                    
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}


              </div>

          </div>
        </div>
        <div id="details" className="scroll-mt-28 space-y-4 md:space-y-6 mb-6">
          <div className="bg-white rounded-xl border border-slate-100 p-4 md:p-6 shadow-sm">
            <h3 className="text-sm md:text-xl font-bold text-slate-800 mb-3 md:mb-4 flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-check mr-1.5 md:mr-2 h-4 w-4 md:h-5 md:w-5 text-green-600"
              >
                <path d="M20 6 9 17l-5-5" />
              </svg>
              What's Included
            </h3>
            <ul className="space-y-2 md:space-y-3">

           {inclusion.map((place, index) => (
              <li key={index} className="flex items-start">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-check mr-2 md:mr-3 mt-0.5 h-4 w-4 md:h-4 md:w-4 flex-shrink-0 text-green-600"
                >
                  <path d="M20 6 9 17l-5-5" />
                </svg>
                <span className="text-sm md:text-base text-slate-600 leading-relaxed">
                   {place}
                </span>
              </li>
          ))}

            </ul>
          </div>
          <div className="bg-white rounded-xl border border-slate-100 p-4 md:p-6 shadow-sm">
            <h3 className="text-sm md:text-xl font-bold text-slate-800 mb-3 md:mb-4 flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-x mr-1.5 md:mr-2 h-4 w-4 md:h-5 md:w-5 text-slate-400"
              >
                <path d="M18 6 6 18" />
                <path d="m6 6 12 12" />
              </svg>
              Not Included
            </h3>
            <ul className="space-y-2 md:space-y-3">
            {exclusion.map((exclusiondata, index) => (
              <li className="flex items-start">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-x mr-2 md:mr-3 mt-0.5 h-4 w-4 md:h-4 md:w-4 flex-shrink-0 text-slate-400"
                >
                  <path d="M18 6 6 18" />
                  <path d="m6 6 12 12" />
                </svg>
                <span className="text-sm md:text-base text-slate-600 leading-relaxed">
                  {exclusiondata}
                </span>
              </li>
            ))}
            </ul>
          </div>
          <div className="bg-white rounded-xl border border-slate-100 p-4 md:p-6 shadow-sm">
            <h3 className="text-sm md:text-xl font-bold text-slate-800 mb-3 md:mb-4 flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-info mr-1.5 md:mr-2 h-4 w-4 md:h-5 md:w-5 text-primary"
              >
                <circle cx={12} cy={12} r={10} />
                <path d="M12 16v-4" />
                <path d="M12 8h.01" />
              </svg>
              Requirements
            </h3>
            <ul className="space-y-2 md:space-y-3">
            
            {meal.map((mealdata, index) => (
              <li className="flex items-start">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-shield mr-2 md:mr-3 mt-0.5 h-4 w-4 md:h-4 md:w-4 flex-shrink-0 text-primary"
                >
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" />
                </svg>
                <span className="text-sm md:text-base text-slate-600 leading-relaxed">
                  {mealdata}
                </span>
              </li>
            ))}

            </ul>
          </div>
          <div className="bg-white rounded-xl border border-slate-100 p-4 md:p-6 shadow-sm">
            <h3 className="text-sm md:text-xl font-bold text-slate-800 mb-3 md:mb-4">
              What to Bring
            </h3>
            <div className="grid grid-cols-2 gap-2 md:gap-3">
          
          {special_notes.map((specialnotesdata, index) => (
              <div className="flex items-center text-xs md:text-sm text-slate-600 bg-slate-50 p-2 md:p-2.5 rounded-md">
                <div className="mr-1.5 h-1.5 w-1.5 md:h-2 md:w-2 rounded-full bg-primary flex-shrink-0" />
                {specialnotesdata}
              </div>
          ))}
            </div>
          </div>
          <div className="bg-white rounded-xl border border-slate-100 p-4 md:p-6 shadow-sm">
            <h3 className="text-sm md:text-xl font-bold text-slate-800 mb-3 md:mb-4">
              Cancellation Policy
            </h3>
            <p className="text-sm md:text-base text-slate-600 leading-relaxed">
              {GroupTripsDtl.cancellation_policy
              ? GroupTripsDtl.cancellation_policy
                  .replace(/<li>/g, '• ')    // replace <li> with bullet
                  .replace(/<\/li>/g, '\n')
                  .replace(/<[^>]+>/g, '')
              : "No available information"}
            </p>
          </div>
          <div className="bg-white rounded-xl border border-slate-100 p-4 md:p-6 shadow-sm">
            <h3 className="text-sm md:text-xl font-bold text-slate-800 mb-3 md:mb-4 flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-map mr-1.5 md:mr-2 h-4 w-4 md:h-5 md:w-5 text-primary"
              >
                <polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21" />
                <line x1={9} x2={9} y1={3} y2={18} />
                <line x1={15} x2={15} y1={6} y2={21} />
              </svg>
              Meeting Point
            </h3>
            <p className="text-sm md:text-base text-slate-600 mb-3 md:mb-3">
              ISBT Shimla, Himachal Pradesh
            </p>
            <button className="inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input hover:bg-accent hover:text-accent-foreground rounded-md px-3 text-xs md:text-sm h-9 md:h-10 bg-transparent">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-map-pin mr-1.5 h-4 w-4 md:h-4 md:w-4"
              >
                <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                <circle cx={12} cy={10} r={3} />
              </svg>
              View on Maps
            </button>
          </div>
        </div>
        <div id="faqs" className="scroll-mt-28 mb-6">
          <div className="bg-white rounded-xl border border-slate-100 p-4 md:p-6 shadow-sm">
            <h3 className="text-base md:text-xl font-bold text-slate-800 mb-4 md:mb-6">
              Frequently Asked Questions
            </h3>
            <div className="space-y-4 md:space-y-6">
              <div className="border-b border-slate-100 last:border-0 pb-3 md:pb-4 last:pb-0">
                <h4 className="text-sm md:text-base font-semibold text-slate-800 mb-1.5 md:mb-2">
                  Is this trip suitable for first-timers?
                </h4>
                <p className="text-sm md:text-sm text-slate-600 leading-relaxed">
                  While no prior experience is needed, you should be comfortable
                  with cold weather and basic physical challenges. Our guides
                  provide full support throughout.
                </p>
              </div>
              <div className="border-b border-slate-100 last:border-0 pb-3 md:pb-4 last:pb-0">
                <h4 className="text-sm md:text-base font-semibold text-slate-800 mb-1.5 md:mb-2">
                  What about altitude sickness?
                </h4>
                <p className="text-sm md:text-sm text-slate-600 leading-relaxed">
                  We carry oxygen cylinders and first aid. Our itinerary is
                  designed with gradual altitude gain. If you have any medical
                  conditions, please consult your doctor before booking.
                </p>
              </div>
              <div className="border-b border-slate-100 last:border-0 pb-3 md:pb-4 last:pb-0">
                <h4 className="text-sm md:text-base font-semibold text-slate-800 mb-1.5 md:mb-2">
                  How cold does it get?
                </h4>
                <p className="text-sm md:text-sm text-slate-600 leading-relaxed">
                  Temperatures can drop to -15°C to -20°C at night. Warm
                  clothing is essential. We provide tips on what to pack after
                  booking.
                </p>
              </div>
              <div className="border-b border-slate-100 last:border-0 pb-3 md:pb-4 last:pb-0">
                <h4 className="text-sm md:text-base font-semibold text-slate-800 mb-1.5 md:mb-2">
                  Are mobile networks available?
                </h4>
                <p className="text-sm md:text-sm text-slate-600 leading-relaxed">
                  Network connectivity is limited in Spiti. BSNL and Airtel work
                  in some areas. It's a perfect digital detox opportunity!
                </p>
              </div>
            </div>
          </div>
        </div>
     </>
  );
};

export default GrouptripsDtlmenu;
